<header>
    <dx-toolbar class="header-toolbar">
        @if (menuToggleEnabled) {
            <dxi-item
                location="before"
                widget="dxButton"
                cssClass="menu-button"
                [options]="{
                    icon: 'menu',
                    stylingMode: 'text',
                    onClick: toggleMenu
                }"
            >
            </dxi-item>
        }
        @if (appTitle) {
            <dxi-item location="before" cssClass="header-title" [text]="appTitle">
                <div *dxTemplate class="header-title" (click)="goHome()">{{ appTitle }}</div>
            </dxi-item>
        }
        <dxi-item location="before">
            <div *dxTemplate>
                <dx-menu
                    #menu
                    [items]="mainMenuItems"
                    displayExpr="text"
                    [showFirstSubmenuMode]="{
                        name: 'onClick',
                        delay: { show: 0, hide: 300 }
                    }"
                    orientation="horizontal"
                    submenuDirection="auto"
                    [hideSubmenuOnMouseLeave]="false"
                    class="main-menu ms-3"
                    itemTemplate="items"
                >
                    <div *dxTemplate="let item of 'items'" class="dx-menu-item-has-text">
                        @if (!item.items) {
                            <a [routerLink]="[item.url]" class="dx-menu-item-text" routerLinkActive="active">{{ item.text }}</a>
                        }
                        @if (item.items) {
                            <span class="dx-menu-item-text" [ngClass]="{ active: isActiveItem(item.url) }">{{ item.text }}</span>
                        }
                    </div>
                </dx-menu>
            </div>
        </dxi-item>
        <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
            <div *dxTemplate="let data of 'item'">
                @if (false) {
                    <div class="d-inline-block">
                        <dx-button class="ms-3" stylingMode="text">
                            <div *dxTemplate="let data of 'content'" class="d-flex">
                                <i class="fa fa-bell" style="font-size: 20px"></i>
                                <span class="badge text-bg-danger align-self-start"></span>
                            </div>
                        </dx-button>
                    </div>
                }

                <dx-button class="user-button authorization ms-3" x-width="170px" height="100%" stylingMode="text">
                    <div *dxTemplate="let data of 'content'">
                        <app-user-panel [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
                    </div>
                </dx-button>
            </div>
        </dxi-item>
        <div *dxTemplate="let data of 'menuItem'">
            <app-user-panel [menuItems]="userMenuItems" menuMode="list"></app-user-panel>
        </div>
        <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem"> v{{ appInfo.appVersion }} </dxi-item>
    </dx-toolbar>
</header>
